import { Form } from 'antd';
import React, { useEffect } from 'react';

import { ERROR_MESSAGE } from '../../../utils/constants';
import FormItem from '../../Form/FormItem';
import Text from '../../Text';
import TextInput from '../../TextInput';

const EditReceiptForm = props => {
  const { t, formInstance, initialValues, isSubmitting } = props;
  const isStartingMonthProration = initialValues?.proration?.startingMonthProration;

  useEffect(() => {
    formInstance.setFieldsValue(initialValues);
    return () => {
      formInstance.resetFields();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Form form={formInstance}>
      <FormItem
        required
        name="totalAmount"
        label={t('totalAmount')}
        rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
      >
        <TextInput disabled={isSubmitting} />
      </FormItem>

      {isStartingMonthProration && (
        <>
          <Text size="sm" variant="strong">
            {t('prorationData')}
          </Text>
          <FormItem
            required
            name={['proration', 'prorationMethod']}
            label={t('prorationMethod')}
            rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
          >
            <TextInput disabled={true} />
          </FormItem>
          <FormItem
            required
            name={['proration', 'numberOfWorkingDaysInMonth']}
            label={t('numberOfWorkingDaysInMonth')}
            rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
          >
            <TextInput disabled={isSubmitting} />
          </FormItem>
          <FormItem
            required
            name={['proration', 'numberOfWorkedDays']}
            label={t('numberOfWorkedDays')}
            rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
          >
            <TextInput disabled={isSubmitting} />
          </FormItem>
          <FormItem
            required
            name={['proration', 'baseFixedAmount']}
            label={t('baseFixedAmount')}
            rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
          >
            <TextInput disabled={isSubmitting} />
          </FormItem>
          <FormItem
            required
            name={['proration', 'proratedFixedAmount']}
            label={t('proratedFixedAmount')}
            rules={[{ required: true, message: ERROR_MESSAGE().BLANK_FIELD }]}
          >
            <TextInput disabled={isSubmitting} />
          </FormItem>
        </>
      )}
    </Form>
  );
};

export default EditReceiptForm;
